// MUVNA — progressive enhancement: AJAX add-to-cart.
// The customer stays on the current page after adding to cart (no redirect).
// When settings.cart_type is "drawer" it still opens the slide-out drawer as
// before; the full "Tu bolsa" cart page is reached only via the cart icon in
// the header, which already links to /cart when cart_type is "page".
// Scoped to the legacy `.shopify-product-form` used by this theme's product
// page and product-card quick-add forms, so it never interferes with any
// native Horizon product-form-component elsewhere.
(function () {
  function openCartDrawer() {
    var dialog = document.querySelector('#cart-drawer dialog');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawerSection() {
    return fetch(location.pathname + '?sections=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (!html) return;
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (wrapper) {
          wrapper.innerHTML = html;
        }
      })
      .catch(function (err) { console.error('MUVNA cart drawer refresh failed', err); });
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('.shopify-product-form, #ProductForm')) return;
    evt.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCounts(cart.item_count);

        // Stay on the current page. If the drawer is enabled from the theme
        // editor, still open it for a quick confirmation; otherwise the
        // customer simply keeps browsing and can open the bag from the
        // header cart icon whenever they're ready.
        if (window.MUVNA_CART_TYPE === 'drawer') {
          return refreshCartDrawerSection().then(openCartDrawer);
        }
      })
      .catch(function (err) {
        console.error('MUVNA add to cart failed', err);
        // Fall back to a normal (non-AJAX) submission so the customer can still buy.
        form.submit();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
})();
